import { createAction, props } from '@ngrx/store'
import { Observable } from 'rxjs'

export const setLoading = createAction('[Loader] Set Loading', props<{ id: string }>())

export const setLoadingComplete = createAction('[Loader] Set Loading Complete', props<{ id: string }>())

export const showLoaderDialog = createAction('[Loader] Show Loader Dialog', props<{ id: string; label?: string }>())

export const hideLoaderDialog = createAction('[Loader] Hide Loader Dialog', props<{ id: string }>())

export const clearActionsInProgress = createAction('[Loader] Clear Actions In Progress')

export const showProgressSpinnerDialog = createAction(
  '[Loader] Show Progress Spinner Dialog',
  props<{ id: string; progress$: Observable<number>; label?: string }>(),
)

export const hideProgressSpinnerDialog = createAction('[Loader] Hide Progress Spinner Dialog', props<{ id: string }>())
